import * as React from 'react';
import Link from 'components/Link';
import Text from 'components/Text';
// @ts-ignore
import { Organization } from './types';
import { MouseEventHandler } from 'types/typescript/eventHandlers';

import './styles/OrganizationPickerSelectedItem.scss';

type Props = {
  organization: Organization; // The organization to display
  /* Called when the user request to change the selected organization
   */
  onChange: MouseEventHandler;
};

export default function OrganizationPickerSelectedItem(props: Props) {
  const { organization: { city, state, name }, onChange } = props;
  const address = [city, state].filter(Boolean).join(', ');

  return (
    <div className="OrganizationPickerSelectedItem">
      <div className="OrganizationPickerSelectedItem-info">
        <Text element="div" weight="semibold">
          {name}
        </Text>
        <Text element="div">{address}</Text>
      </div>
      <div>
        <Link onClick={onChange}>
          <Text>Change</Text>
        </Link>
      </div>
    </div>
  );
}
